import { Card, CardBody, Col, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BordersWithIcon } from "../../../../Constant";
import { BORDER_ICON_SWITCH_LIST, BORDER_ICON_SWITCH } from "../../../../Data/FormWidgets";
import CommonSwitchSpan from "../Common/CommonSwitchSpan";

const BordersWithIcons = () => {
  return (
    <Col xl="4">
      <Card className="height-equal">
        <CommonCardHeader title={BordersWithIcon} span={BORDER_ICON_SWITCH} />
        <CardBody className="common-flex flex-column switch-wrapper ">
          {BORDER_ICON_SWITCH_LIST.map(({ color, text }, index) => (
            <div className="d-flex align-items-center" key={index}>
              <div className="text-end icon-state switch-outline">
                <CommonSwitchSpan color={color} defaultChecked />
              </div>
              <Label className="m-l-10" check>{text}</Label>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  )
}

export default BordersWithIcons